/**
 * Functionality for basic modal window. Note you trigger any anchor tag
 * to open in a modal by attaching the `data-modal` attribute.
 * The anchor's href will be used as an iframe src.
 * For opening webforms in a modal, you should not use this component. Instead,
 * use the Drupal core modal.
 *
 * Attach a `data-modal-type` attribute to specify an additional class for styling.
 * `form` value will create a narrower window and move close button to outside the modal.
 *
 * @author Todd Miller <todd.miller@tricomb2b.com>
 */

(function ($) {
  'use strict';

  let $modals;

  Drupal.behaviors.initializeModalWindows = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  /**
   * Just strip the modals from the DOM.
   */
  function handleModalClose() {
    $('.modal-wrapper').fadeTo('fast', 0, function () {
      $(this).remove();
    });
    $('body').removeClass('scroll-lock');
  }

  /**
   * Set up the markup for a new modal element and attach it to the DOM.
   */
  function handleModalOpen(e) {
    e.preventDefault();
    $('body').addClass('scroll-lock');

    // Check for a type attribute to use as a class.
    const modalType = $(e.currentTarget).attr('data-modal-type');
    const typeClass = modalType ? ' ' + modalType : '';

    const src = $(e.currentTarget).attr('href');
    const $wrapper = $('<div class="modal-wrapper' + typeClass + '"></div>"');
    const $close = $('<div class="close"></div>');
    const $inner = $('<div class="inner"></div>');
    const $overlay = $('<div class="overlay"></div>');
    const $iframe = $(`<iframe src="${src}" allowfullscreen></iframe>`);

    $inner.append($close).append($iframe);
    $wrapper.append($overlay).append($inner);

    $('body').append($wrapper);
    $('.modal-wrapper').fadeTo('fast', 1);
    $('.modal-wrapper .close').on('click', handleModalClose);
  }

  /**
   * Cache elements, attach event handlers.
   */
  function initialize() {
    $modals = $('[data-modal]');

    if (!$modals.length) return false;

    $modals.on('click', handleModalOpen);
  }
})(jQuery);
